import { render, staticRenderFns } from "./DaftarBaukPo.vue?vue&type=template&id=c472a018&scoped=true"
import script from "./DaftarBaukPo.vue?vue&type=script&lang=js"
export * from "./DaftarBaukPo.vue?vue&type=script&lang=js"
import style0 from "./DaftarBaukPo.vue?vue&type=style&index=0&id=c472a018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472a018",
  null
  
)

export default component.exports